import { useRef } from "react";
import { RigidBody } from "@react-three/rapier";
import { useFrame } from "@react-three/fiber";
import { threeColors } from "../theme/tokens";
import { CUBE_DESPAWN_Y } from "../config/game";
import { useGameStore } from "../state/useGameStore";

function FragmentCube({ cube }) {
  const body = useRef();
  const removeCube = useGameStore((s) => s.removeCube);

  useFrame(() => {
    const api = body.current;
    if (!api) return;
    if (api.translation().y < CUBE_DESPAWN_Y) {
      removeCube(cube.id);
    }
  });

  const dense = cube.variant === "dense";
  const compact = cube.variant === "compact";
  const color = compact
    ? threeColors.paper
    : dense
      ? threeColors.signal
      : threeColors.metal;
  const emissive = compact
    ? threeColors.gray
    : dense
      ? threeColors.signal
      : threeColors.metalMid;

  return (
    <RigidBody
      ref={body}
      colliders="cuboid"
      position={cube.position}
      linearVelocity={cube.linearVelocity}
      angularVelocity={cube.angularVelocity}
      friction={compact ? 0.95 : 0.85}
      restitution={cube.restitution ?? (compact ? 0.04 : 0.12)}
      linearDamping={compact ? 0.5 : 0.35}
      angularDamping={compact ? 0.55 : 0.45}
      mass={cube.mass ?? (compact ? 0.75 : 0.4)}
    >
      <mesh castShadow>
        <boxGeometry args={[cube.scale, cube.scale, cube.scale]} />
        <meshStandardMaterial
          color={color}
          metalness={compact ? 0.68 : 0.55}
          roughness={compact ? 0.32 : 0.4}
          emissive={emissive}
          emissiveIntensity={compact ? 0.32 : dense ? 0.45 : 0.2}
        />
      </mesh>
    </RigidBody>
  );
}

export function FragmentCubes() {
  const cubes = useGameStore((s) => s.cubes);
  return (
    <group>
      {cubes.map((cube) => (
        <FragmentCube key={cube.id} cube={cube} />
      ))}
    </group>
  );
}
